import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { Row, Col } from 'react-flexbox-grid'
import {Doughnut} from 'react-chartjs'
import {SlideDown} from 'react-slidedown'
import ReactTooltip from 'react-tooltip'
import config from '../../config'
import convert from '../../helpers/convert'
import format from '../../helpers/format'
import {
  YesNo,
  Link,
  LinkIcon,
} from '../../components'

import Styles from './PlanScorecardInvestmentOptions.css'


@CSSModules(Styles,{allowMultiple:true})
class FundRowFullHeader extends Component {
  static propTypes = {
    noAssets: PropTypes.bool
  }
  render(){
    return (
      <tr styleName='dtls-tbl-row'>
        <th styleName='dtls-tbl-lbl c'>
          Plan option
        </th>
        <th styleName='dtls-tbl-val c'>
          Rated as*
        </th>
        <th styleName='dtls-tbl-val c'>
          Sustainable investment
        </th>
        <th styleName='dtls-tbl-val c'>
          Fossil fuels
        </th>
        <th styleName='dtls-tbl-val c'>
          Deforestation
        </th>
        <th styleName='dtls-tbl-val c'>
          Gender equality
        </th>
        <th styleName='dtls-tbl-val c'>
          Civilian firearms
        </th>
        <th styleName='dtls-tbl-val c'>
          Prison industrial complex
        </th>
        <th styleName='dtls-tbl-val c'>
          Military weapons
        </th>
        <th styleName='dtls-tbl-val c'>
          Tobacco
        </th>
        {
          this.props.noAssets ?
            null :
            (
              <th styleName='dtls-tbl-val c'>
                Plan assets
              </th>

            )
        }
      </tr>
    )
  }
}


@CSSModules(Styles,{allowMultiple:true})
class ClosedNotRated extends Component {
  render(){
    return (
      <div
        styleName='grade-0'
        data-multiline
        data-effect='solid'
        data-html
        data-for='grade-0-tooltip'
        data-place='bottom'
        data-tip={
          '<div style=\'max-width:200px;\'>This fund has been closed to new investors. Existing investors continue to own the fund, but we no longer have access to the holdings, so we don\'t have ratings for this investment option. </div>'
        }
      >
        -
        <ReactTooltip id='grade-0-tooltip'/>
      </div>
    )
  }
}


@CSSModules(Styles,{allowMultiple:true})
class NoMatchNotRated extends Component {
  render(){
    // Retirement plans often invest in
    // opaque funds called "collective trusts". To get around
    // this, we identify mutual funds that are suitable replacements
    // to use for our ratings. But sometimes, we aren't able to find
    // a suitable mutual fund. In that case, we don't have ratings
    // for that investment option.
    return (
      <div
        styleName='grade-0'
        data-multiline
        data-effect='solid'
        data-html
        data-for='grade-0-tooltip'
        data-place='bottom'
        data-tip={
          `
          <div style='max-width:200px;'>
            Missing data for this fund. 
          </div>
          `
        }
      >
        -
        <ReactTooltip id='grade-0-tooltip'/>
      </div>
    )
  }
}


@CSSModules(Styles,{allowMultiple:true})
class TSPLFundRated extends Component {
  render(){
    return (
      <div
        styleName='grade-0'
        data-multiline
        data-effect='solid'
        data-html
        data-for='grade-0-tooltip'
        data-place='bottom'
        data-tip={
          `<div style='max-width:200px;'>
            The target date L Funds are composed of different mixes of the
            individual C, S, I, F, and G funds.
            To analyze the TSP L Funds, we mapped the underlying individual
            funds to matching index funds,
            then modeled the different allocation mixes of each L fund
            portfolio.
          </div>`
        }
      >
        -
        <ReactTooltip id='grade-0-tooltip'/>
      </div>
    )
  }
}


@CSSModules(Styles,{allowMultiple:true})
class TSPIndFundRated extends Component {
  render(){
    return (
      <div
        styleName='grade-0'
        data-multiline
        data-effect='solid'
        data-html
        data-for='grade-0-tooltip'
        data-place='bottom'
        data-tip={
          `<div style='max-width:200px;'>
            The Thrift Savings Plan
            individual C, S, I, F, and G funds
            do not publish full
            portfolio holdings, but they track indexes that
            are shared with other mutual funds.
            To analyze these funds, we mapped them to matching index funds.
          </div>`
        }
      >
        -
        <ReactTooltip id='grade-0-tooltip'/>
      </div>
    )
  }
}


@CSSModules(Styles,{allowMultiple:true})
class LowEquityNotRated extends Component {
  render(){
    return (
      <div
        styleName='grade-0'
        data-multiline
        data-effect='solid'
        data-html
        data-for='grade-0-tooltip'
        data-place='bottom'
        data-tip={
          '<div style=\'max-width:200px;\'>We only rate funds that are at ' +
            'least 50% invested in equities. This fund did not reach that ' +
            'threshold.</div>'
        }
      >
        -
        <ReactTooltip id='grade-0-tooltip'/>
      </div>
    )
  }
}


@CSSModules(Styles,{allowMultiple:true})
class TableDisclaimerFull extends Component {
  render(){
    return (
      <div styleName='table-disclaimer-full'>
        * Where possible, we rate the exact investment option offered by the
        retirement plan.
        But often, retirement plans use opaque funds called "collective
        trusts" that don't publish their holdings.
        Usually, these opaque funds are also offered as mutual funds by the
        same asset manager, with the full holdings published on the SEC's
        website.
        Whenever a plan offers collective trusts, we identify mutual funds
        that are suitable replacements to use for our ratings.
        The funds used for these ratings are noted in the "Rated as"
        column. <Link
          to={config.routes.methodology}
          title='Methodology'
          xstrong
        >
          Read our full methodology<LinkIcon />
        </Link>
      </div>
    )
  }
}


@CSSModules(Styles,{allowMultiple:true})
class FundRowHeader extends Component {
  static propTypes = {
    noAssets: PropTypes.bool
  }
  render(){
    return (
      <Row styleName='dtls-tbl-row'>
        <Col xs={8} styleName='dtls-tbl-lbl c'>
          <b>Plan option</b>
        </Col>
        {
          this.props.noAssets ?
            null :
            (
              <Col xs={4} styleName='dtls-tbl-val c'>
                <b>Plan assets</b>
              </Col>
            )
        }
      </Row>
    )
  }
}


@CSSModules(Styles,{allowMultiple:true})
class FundRowSlim extends Component {
  static propTypes = {
    investmentOption: PropTypes.object.isRequired
  }
  constructor(props){
    super(props)
    this.state = {
      investmentOption: props.investmentOption
    }
  }
  render(){
    const { investmentOption } = this.state
    const rowStyle = investmentOption.length > 3 ? 'strong' : ''
    const moneyFormatted = format.money(
      investmentOption.assets,
      true,
      'US Dollar',
      false,
      1
    )
    return (
      <Row styleName={'dtls-tbl-row ' + rowStyle}>
        <Col xs={8} styleName='dtls-tbl-lbl'>
          <span>{investmentOption.label}</span>
        </Col>
        {
          moneyFormatted === '$0' ?
            null :
            (
              <Col xs={4} styleName='dtls-tbl-val r'>
                <span>
                  {moneyFormatted}
                </span>
              </Col>
            )
        }
      </Row>
    )
  }
}


@CSSModules(Styles,{allowMultiple:true})
class FundRowFull extends Component {
  static propTypes = {
    investmentOption: PropTypes.object.isRequired
  }

  constructor(props){
    super(props)
    this.state = {
      investmentOption: props.investmentOption
    }
  }

  gradeIntToChar(g){
    if (g === -1) {
      return 'N/A'
    } else if (g === 0 || g) {
      return {
        0: 'TK',
        1: 'A',
        1.5: 'Engagement',
        2: 'B',
        3: 'C',
        4: 'D',
        5: 'F',
        6: 'F',
      }[g]
    } else {
      return null
    }
  }

  render(){
    const { investmentOption } = this.state

    investmentOption.grade_fossil = investmentOption.grade_fossil || 0
    investmentOption.grade_deforestation = investmentOption.grade_deforestation || 0
    investmentOption.grade_gender_equality = investmentOption.grade_gender_equality || 0
    investmentOption.grade_guns = investmentOption.grade_guns || 0
    investmentOption.grade_prison_industrial_complex = investmentOption.grade_prison_industrial_complex || 0
    investmentOption.grade_military = investmentOption.grade_military || 0
    investmentOption.grade_tobacco = investmentOption.grade_tobacco || 0

    // // make ticker safe for URL
    const sTicker = investmentOption.ticker || 'N'
    const urlBuilder = (route, profilePath, query=null) => {
      let url = route + '/' +
        format.sanitize(investmentOption.fund_legal_name) + '/' +
        sTicker + '/' +
        profilePath + '/' +
        investmentOption.fund_id + '/' +
        investmentOption.investment_vehicle_id
      if (query) {
        url += '?' + query
      }
      return url
    }

    const fffUrl = urlBuilder(config.links.fff + '/fund', 'fossil-fuel-investments')
    const dffUrl = urlBuilder(config.links.dff + '/fund', 'profile')
    const gefUrl = urlBuilder(config.links.gef + '/fund', 'gender-lens-score')
    const gffUrl = urlBuilder(config.links.gff + '/fund', 'gun-investments')
    const pffUrl = urlBuilder(config.links.pff + '/fund', 'prison-industrial-complex-investments')
    const wffUrl = urlBuilder(config.links.wff + '/fund', 'weapon-investments')
    const tffUrl = urlBuilder(config.links.tff + '/fund', 'tobacco-profile')

    const formattedMoney = format.money(
      investmentOption.assets,
      true,
      'US Dollar',
      false,
      1
    )

    // TSP hack
    let isTSP = false
    if (['FTSP0LINCM', 'FTSP0L2025',
         'FTSP0L2030', 'FTSP0L2035',
         'FTSP0L2040', 'FTSP0L2045',
         'FTSP0L2050', 'FTSP0L2055',
         'FTSP0L2060', 'FTSP0L2065',
         'FTSP0L2060', 'FTSP0L2065',
         'FTSP00000C', 'FTSP00000S',
         'FTSP00000I'].includes(investmentOption.fund_id)) {
      isTSP = true
    }

    //
    return (
      <tr styleName='dtls-tbl-row'>
        <td styleName='dtls-tbl-lbl'>
           <span>{investmentOption.label}</span>
        </td>
        <td styleName='dtls-tbl-val c'>
          {
            investmentOption.ticker ?
              investmentOption.ticker :
              investmentOption.label.includes('2015') ?
                <ClosedNotRated /> :
                !isTSP ?
                  <NoMatchNotRated /> :
                    investmentOption.label.includes('L') ?
                      <TSPLFundRated /> :
                      <TSPIndFundRated />
          }
        </td>
        <td styleName='dtls-tbl-val c'>
          { // if rated, show a yes/no
            investmentOption.percent_rated_long > 0.5 ?
              <YesNo
                yes={convert.boolean(investmentOption.sustainable_investment)}
              /> : // if not rated, is there a ticker? if ticker, show yes/no
                investmentOption.ticker ?
                  <YesNo
                    yes={convert.boolean(investmentOption.sustainable_investment)}
                  /> : // if no ticker, is there 2015 in name? (i.e. closed)
                  investmentOption.label.includes('2015') ?
                    <ClosedNotRated /> : // if yes, show "closed"
                    <NoMatchNotRated /> // if not, show "no match"
          }
        </td>

        {
          [
            [fffUrl, 'Fossil Free Funds', 'grade_fossil'],
            [dffUrl, 'Deforestation Free Funds', 'grade_deforestation'],
            [gefUrl, 'Gender Equality Funds', 'grade_gender_equality'],
            [gffUrl, 'Gun Free Funds', 'grade_guns'],
            [pffUrl, 'Prison Free Funds', 'grade_prison_industrial_complex'],
            [wffUrl, 'Weapon Free Funds', 'grade_military'],
            [tffUrl, 'Tobacco Free Funds', 'grade_tobacco']
          ].map((e, i) => {
            const [url, siteName, gradeLabel] = e
            return (
              <td styleName={'dtls-tbl-val c h3 block'}>
                {
                  investmentOption.percent_rated_long > 0.5 ?
                    <Link
                      to={url}
                      title={
                        `${investmentOption.fund_legal_name} - ${siteName}`
                      }
                    >
                      <div styleName={'grade-'+investmentOption[gradeLabel]}>
                        { this.gradeIntToChar(investmentOption[gradeLabel]) }
                      </div>
                    </Link> :
                      investmentOption.ticker || isTSP ?
                        <LowEquityNotRated /> :
                        investmentOption.label.includes('2015') ?
                          <ClosedNotRated /> :
                          <NoMatchNotRated />
                }
              </td>

            )
          })
        }

        {
          formattedMoney === '$0' ?
            null :
            (
              <td styleName='dtls-tbl-val r'>
                <span>
                  {
                    format.money(
                      investmentOption.assets,
                      true,
                      'US Dollar',
                      false,
                      1
                    )
                  }
                </span>
              </td>
            )
        }
      </tr>
    )
  }
}


@CSSModules(Styles,{allowMultiple:true})
export default class PlanScorecardInvestmentOptions extends Component {
  static propTypes = {
    planId: PropTypes.string,
    allocationStats: PropTypes.object.isRequired,
    planOptions: PropTypes.object.isRequired
  }
  constructor(props){
    super(props)
    this.state = {
      showInvestmentOptions: false,
      allocationStats: props.allocationStats,
      planOptions: props.planOptions,
      planId: props.planId || null,
    }
  }

  //
  render() {
    const { planId, allocationStats, planOptions, showInvestmentOptions } = this.state

    //
    return(
      <div>
        <button
          styleName='section-slidedown-button'
          onClick={
            (e)=>{
              this.setState({
                showInvestmentOptions: !showInvestmentOptions
              })
            }
          }
        >
          <h2 styleName='section-slidedown-label'>
            Plan investment options
          </h2>
          <div styleName='section-slidedown-icon'>
            <LinkIcon
              faclass={
                showInvestmentOptions ?
                 'fa-angle-up' :
                 'fa-angle-down'
              }
            />
          </div>
        </button>
        <SlideDown>
          {
            showInvestmentOptions ?
              <div styleName='investment-options-wrap'>
                {  planId && planId === 'thrift-savings-plan' ?
                  <div styleName='tsp-disclaimer'>
                    <div styleName='tsp-disclaimer-icon'>
                      <LinkIcon nospace faclass='fa-info-circle' />
                    </div>
                    <p>
                      Like most retirement plans, The Thrift Savings Plan is
                      composed of target date funds, as well as individual
                      equity and bond funds.

                      But the Thrift Savings Plan is unique in that the
                      target date L Funds are themselves composed of the
                      individual C, S, I, F, and G funds.

                      The "percentage of plan assets" figures below
                      for target dates, equity,
                      bond/fixed income, and other funds
                      have been adjusted to account for this, to avoid
                      double counting.

                      The plan assets for the individual funds
                      have not been adjusted,
                      and represent the total amount invested in those funds,
                      including via the target date L Funds.
                    </p>
                  </div> :
                  null
                }
                <div styleName='plan-option-card'>
                  <h3 styleName='table-strong'>
                    Target dates
                  </h3>
                  {
                    allocationStats.default.percStr === 'NaN%' ?
                      null :
                      (
                        <div styleName='doughnut-flex'>
                          <Doughnut
                            data={[
                              { value: allocationStats.default.perc,
                                // label: 'Other',
                                color: '#313131' },
                              { value: allocationStats.default.percOther,
                                // label: null,
                                color: '#D5D5D5' }
                            ]}
                            options={config.chartOptions}
                            width='150'
                            height='150'
                          />
                          <div styleName='doughnut-flex-text'>
                            <b>{allocationStats.default.count}</b> plan {
                              format.maybePluralize(allocationStats.default.count, 'option')
                            }
                            <br/>
                            <b>{allocationStats.default.percStr}</b> of plan assets
                          </div>
                        </div>
                      )
                  }
                  <table styleName='full-row-table'>
                    <thead>
                      <FundRowFullHeader noAssets={allocationStats.default.percStr === 'NaN%'} />
                    </thead>
                    <tbody>
                      {
                        planOptions.default.map((e, i)=>{
                          return (
                            <FundRowFull
                              key={'fund-row-default-' + i}
                              investmentOption={e}
                            />
                          )
                        })
                      }
                    </tbody>
                  </table>
                  <TableDisclaimerFull />
                </div>

                <div styleName='plan-option-card'>
                  <h3 styleName='table-strong'>
                    Equity funds
                  </h3>
                  {
                    allocationStats.default.percStr === 'NaN%' ?
                      null :
                      (
                        <div styleName='doughnut-flex'>
                          <Doughnut
                            data={[
                              { value: allocationStats.equity.perc,
                                // label: 'Other',
                                color: '#313131' },
                              { value: allocationStats.equity.percOther,
                                // label: null,
                                color: '#D5D5D5' }
                            ]}
                            options={config.chartOptions}
                            width='150'
                            height='150'
                          />
                          <div styleName='doughnut-flex-text'>
                            <b>{allocationStats.equity.count}</b> plan {
                              format.maybePluralize(allocationStats.equity.count, 'option')
                            }
                            <br/>
                            <b>{allocationStats.equity.percStr}</b> of plan assets
                          </div>
                        </div>
                      )
                  }
                  <table styleName='full-row-table'>
                    <thead>
                      <FundRowFullHeader noAssets={allocationStats.default.percStr === 'NaN%'} />
                    </thead>
                    <tbody>
                      {
                        planOptions.equity.map((e, i)=>{
                          return (
                            <FundRowFull
                              key={'fund-row-equity-' + i}
                              investmentOption={e}
                            />
                          )
                        })
                      }
                    </tbody>
                  </table>
                  <TableDisclaimerFull />
                </div>

                <div styleName='bond-other-cards-flex'>
                  <div styleName='plan-option-card'>
                    <h3 styleName='table-strong'>
                      Bond/fixed income funds
                    </h3>
                    {
                      allocationStats.default.percStr === 'NaN%' ?
                        null :
                        (
                          <div styleName='doughnut-flex'>
                            <Doughnut
                              data={[
                                { value: allocationStats.bond.perc,
                                  // label: 'Bond funds',
                                  color: '#313131' },
                                { value: allocationStats.bond.percOther,
                                  // label: null,
                                  color: '#D5D5D5' }
                              ]}
                              options={config.chartOptions}
                              width='150'
                              height='150'
                            />
                            <div styleName='doughnut-flex-text'>
                              <b>{allocationStats.bond.count}</b> plan {
                                format.maybePluralize(allocationStats.bond.count, 'option')
                              }
                              <br/>
                              <b>{allocationStats.bond.percStr}</b> of plan assets
                            </div>
                          </div>
                        )
                    }
                    <div styleName='table-disclaimer'>
                      The results above do not include
                      bond/fixed income funds
                      and represent only the rated investment
                      options (target date and equity funds). <b>See
                      our <Link
                        xstrong
                        to={config.routes.fossilFuelBondsIn401ks}
                        title='Fossil fuel bonds in 401(k)s'
                      >new analysis</Link> of fossil fuel bonds in 401(k)s
                      for more information on bond funds.</b>
                    </div>
                    <div styleName='non-scored-funds-table-cell'>
                      <FundRowHeader noAssets={allocationStats.default.percStr === 'NaN%'} />
                      {
                        planOptions.bond.map((e, i)=>{
                          return (
                            <FundRowSlim
                              key={'fund-row-bond-' + i}
                              investmentOption={e}
                            />
                          )
                        })
                      }
                    </div>
                  </div>
                  <div styleName='plan-option-card'>
                    <h3 styleName='table-strong'>
                      Other funds
                    </h3>
                    {
                      allocationStats.default.percStr === 'NaN%' ?
                        null :
                        (
                          <div styleName='doughnut-flex'>
                            <Doughnut
                              data={[
                                { value: allocationStats.other.perc,
                                  // label: 'Other',
                                  color: '#313131' },
                                { value: allocationStats.other.percOther,
                                  // label: null,
                                  color: '#D5D5D5' }
                              ]}
                              options={config.chartOptions}
                              width='150'
                              height='150'
                            />
                            <div styleName='doughnut-flex-text'>
                              <b>{allocationStats.other.count}</b> plan {
                                format.maybePluralize(allocationStats.other.count, 'option')
                              }
                              <br/>
                              <b>{allocationStats.other.percStr}</b> of plan assets
                            </div>
                          </div>
                        )
                    }
                    <div styleName='table-disclaimer'>
                      We don't have ratings for some investment options like
                      money market funds,
                      stable value funds,
                      company stock funds,
                      seperately managed accounts,
                      or anything invested via brokerage windows.
                      The results above represent only the rated investment
                      options (target date and equity funds). <b>There may be
                      additional unsustainable investments in these unrated
                      investment options.</b>
                    </div>
                    <div styleName='non-scored-funds-table-cell'>
                      <FundRowHeader noAssets={allocationStats.default.percStr === 'NaN%'} />
                      {
                        planOptions.other.map((e, i)=>{
                          return (
                            <FundRowSlim
                              key={'fund-row-other-' + i}
                              investmentOption={e}
                            />
                          )
                        })
                      }
                    </div>
                  </div>

                </div>

              </div> :
              null
          }
        </SlideDown>
      </div>
    )
  }
}
